import type { BannerNotification } from "@/store/bannerNotificationStore";
import { useBannerNotificationStore } from "@/store/bannerNotificationStore";
import { useCallback } from "react";

interface UseBannerNotificationReturn {
  add: (notification: BannerNotification) => void;
  dismiss: (id: string) => void;
  dismissAll: () => void;
}

export const useBannerNotification = (): UseBannerNotificationReturn => {
  const add = useBannerNotificationStore((s) => s.add);
  const dismiss = useBannerNotificationStore((s) => s.dismiss);
  const dismissAll = useBannerNotificationStore((s) => s.dismissAll);

  return {
    add: useCallback(add, [add]),
    dismiss: useCallback(dismiss, [dismiss]),
    dismissAll: useCallback(dismissAll, [dismissAll]),
  };
};
